// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"734":"70d3ecd5881a4923","836":"8fe05c4571f44ed9"}[chunkId] + ".js";
};